import React from 'react';
import { Route, Switch } from 'react-router-dom';
import CeateUser from '../../../PnD/UserMgt/CreateUser/View';
import MerchantUser from '../../../PnD/UserMgt/MerchantUser/View';
import StatisticalReport from '../../../PnD/Reports/OrderStatisticalReport';

import DeliveryZoneRate from '../../../PnD/DeliveryRate/View';
import HubDetails from '../../../PnD/Hub/View';
import TerritoryDetails from '../../../PnD/Territory/View/index';
import Vehicle from '../../../PnD/Vehicle/View';
import OutletSetting from '../../../PnD/OutletSetting/View';
import OrderDetails from '../../../PnD/Order/OrderCreation/View';
import OrderCreate from '../../../PnD/Order/OrderCreation/AddOrUpdate';
import PickUpPointsDetails from '../../../PnD/PickUpPoint/View';
import CustomerDetails from '../../../PnD/Customer/AddCustomers/View';
import CustomerAddressBookDetails from '../../../PnD/Customer/CustomerAddressBook/View';
import OrderTransferDetails from '../../../PnD/Order/OrderTransfer/View';
import OrderAssignDetails from '../../../PnD/Order/AssignOrder/View';
import OrderCancellationIndex from '../../../PnD/Order/OrderCancellation/View';
import OrderUnAssgin from '../../../PnD/Order/OrderUnAssign/View';

import PndDefaultDashboard from '../../../PnD/PndDashboard/DefaultDashboard/index';
import InformapClientDetailsView from '../../../PnD/Establishment/View';
//import InformapClientDetailsAdd from '../../../PnD/Establishment/AddOrUpdate';
import InformapClientDetailsAdd from '../../../PnD/Establishment/AddOrUpdate/index';
import MobileDeviceKeyDetails from '../../../PnD/MobileDeviceLicenceKey/View';
import MobileDeviceCancellationLog from '../../../PnD/MobileDeviceCancellationLog/View';
import DriverEmployerDetails from 'src/containers/PnD/DriverEmployer/View/index';
import DriverDetails from '../../../PnD/Driver/View/index';
import ChangeClientAdmin from '../../../PnD/UserMgt/ChangeClientAdmin/index';

import MerchantDetails from 'src/containers/PnD/Merchant/CreateMerchant/View';
import DutyShiftConfig from '../../../PnD/HubDutyShiftConfi/View';
import DutyRoasterView from 'src/containers/PnD/RiderDutyRoaster/index';
import DutyRoasterRegistration from '../../../PnD/RiderDutyRoaster/DutyRoasterRegister';
import TerritoryRegionsListView from '../../../PnD/Territory/View/components/TerritoryRegionsListView';
import OrderRecall from '../../../PnD/Order/OrderRecall/index';
import RiderLocationHistory from '../../../PnD/RiderLocationHistory/View';
import HubOperatorView from '../../../PnD/Views/HubOperatorsView';
import FAQView from '../../../PnD/Views/FAQView';

import RiderView from '../../../PnD/Views/RiderView';
import DutyRoasterHistory from '../../../PnD/RiderDutyRoasterHistory';
import VehicleView from '../../../PnD/Views/VehicleView';
import HubView from '../../../PnD/Views/HubView';
import DriverEmployerView from '../../../PnD/Views/DriverEmployerView';
import CanclledOrderView from '../../../PnD/Views/OrderView/CancelledOrderView';
import WithdrewOrderView from '../../../PnD/Views/OrderView/WithdrawOrderView';
import MerchantCustomer from '../../../PnD/Merchant/MerchantCustomer/AddCustomers/View';
import MerchantCustomerAddrssBook from '../../../PnD/Merchant/MerchantCustomer/CustomerAddressBook/View';
import OrderPunchingOrderView from '../../../PnD/Views/OrderView/PunchedOrderView/index';
import RiderAvailability from '../../../PnD/RiderAavailability/index';
import OrderEdit from '../../../PnD/Order/OrderCreation/AddOrUpdate/index';
import DriverVehicleMappingDetailsIndex from '../../../PnD/Driver-Vehicle-Mapping/index';
import HubPickUpPointsDetails from '../../../PnD/HubPickUpPoint/View';
import RiderPasswordReset from '../../../PnD/UserMgt/RiderUser/View';
import OrderHistory from '../../../PnD/Order/OrderHistory';
import HubLogin from '../../../PnD/Landing/index';
import OrderReturn from '../../../PnD/Order/OrderReturn/index';
import PollingInterval from '../../../PnD/Establishment/PollingIntervel/index'
import ClientAdminScubscriptionDetailsView from '../../../PnD/Views/ClientAdminSubscriptionView/index'
import Faq from '../../../PnD/FAQ/View/index';
import Chat from '../../../../shared/components/ChatBot/Chat';
import OrderReassign from '../../../PnD/Order/OrderReassign/View';
import RiderLiveMap from '../../../PnD/RiderLiveMap';
import RiderWiseOrder from '../../../PnD/Views/RiderCurrentlyProcessingOrderList/index';
import TripHistory from '../../../PnD/RiderTripHistory/index';
import OrderReschedule from '../../../PnD/Order/OrderReschedule/index';
import MerchantView from '../../../PnD/Views/MerchantView/index';
import MobileAppRelease from '../../../PnD/MobileAppRelease/View/index';
import CustomerTagSetting from '../../../PnD/Customer/CustomerTagSettings/View/index';

import SecurityApproval from '../../../PnD/Security/OrderApproval/';
import DeclineOrder from '../../../PnD/Security/DeclineOrder';

import RiderDutyReport from '../../../PnD/Reports/RiderDutyReport/index';
import RiderActivitySummaryReport from '../../../PnD/Reports/RiderActivityReport';
import OrderSummaryReport from '../../../PnD/Reports/OrderSummaryReport';
import OrderDetailedReport from '../../../PnD/Reports/OrderDetailedReport';
import OrderPerformanceReport from '../../../PnD/Reports/OrderPerformanceReport';
import OrderOTRReport from '../../../PnD/Reports/OrderOTRReport/OrderOTRReport';
import OTRIntervalReport from '../../../PnD/Reports/OrderOTRIntervalReport/OrderOTRIntervalReport'
import OrderComplainceDlvReport from 'src/containers/PnD/Reports/ComplianceDlvReport/index';
import OrderFailedReport from 'src/containers/PnD/Reports/OrderFailedReport/index';
import OrderReport from '../../../PnD/Reports/OrderReport/OrderReport';

import OrderDetailsPage from '../../../PnD/Security/OrderDetails/index'; // Import Order Details Page
import SecurityHistory from '../../../PnD/Security/History/index';
import SecurityReport from '../../../PnD/Security/Report/index';
import OrderPreferenceSettings from '../../../PnD/OrderPreferenceSetting/index';
import UserManual from '../../../PnD/UserManual/index';

export default () => (
   <Switch>
      <Route path='/web_app/user_manual/view' component={UserManual} />
      <Route path='/web_app/order/security_approval' component={SecurityApproval} />

      <Route path="/web_app/hub_login" component={HubLogin} />
      <Route path="/web_app/itc/polling_interval" component={PollingInterval} />
      <Route path="/web_app/user_management/create_user/view" component={CeateUser} />
      <Route path="/web_app/user_management/create_merchant_user/view" component={MerchantUser} />
      <Route path='/web_app/user_management/reset_password' component={ChangeClientAdmin} />
      <Route path='/web_app/user_management/rider/reset_password' component={RiderPasswordReset} />
      <Route path='/web_app/itc/faq' component={Faq} />
      <Route path='/web_app/itc/mobile_app_release' component={MobileAppRelease} />
      <Route path='/web_app/chat' component={Chat} />
      <Route path='/web_app/order/order_history' component={OrderHistory} />
      <Route path='/web_app/order/return' component={OrderReturn} />
      <Route path='/web_app/order/unassign' component={OrderUnAssgin} />

      <Route path='/web_app/pnd_hub/duty_shift_confi' component={DutyShiftConfig} />

      <Route path="/web_app/dashboard/pnd_default_dashboard" component={PndDefaultDashboard} />
      <Route path="/web_app/pnd_establishment/view" component={InformapClientDetailsView} />
      <Route path="/web_app/pnd_Info_client/add" component={InformapClientDetailsAdd} />
      <Route path="/web_app/pnd_mobile_device_key/view" component={MobileDeviceKeyDetails} />
      <Route path="/web_app/pnd_mobile_device_cancellation_log/view" component={MobileDeviceCancellationLog} />
      <Route path="/web_app/pnd_delivery_zone_rate/view" component={DeliveryZoneRate} />
      <Route path="/web_app/pnd_hub/view" component={HubDetails} />

      <Route path="/web_app/pnd_territory/view" component={TerritoryDetails} />
      <Route path='/web_app/pnd_territory/region-list/:regionId' component={TerritoryRegionsListView} />

      <Route path="/web_app/pnd_vehicle/view" component={Vehicle} />
      <Route path="/web_app/pnd_outlet_setting/view" component={OutletSetting} />
      <Route path="/web_app/pnd_customer/customer/view" component={CustomerDetails} />
      <Route path="/web_app/pnd_customer/customer_address_book/view" component={CustomerAddressBookDetails} />
      <Route path="/web_app/pnd_pick_up_point/view" component={PickUpPointsDetails} />
      <Route path="/web_app/customer_tag_settings/view" component={CustomerTagSetting} />
      <Route path="/web_app/hub_pick_up_point/view" component={HubPickUpPointsDetails} />
      <Route path="/web_app/faq/view" component={FAQView} />

      <Route path="/web_app/driver-employer/view" component={DriverEmployerDetails} />
      <Route path="/web_app/driver/view" component={DriverDetails} />
      <Route path="/web_app/driver-vehicle/view" component={DriverVehicleMappingDetailsIndex} />
      <Route path="/web_app/pnd_order/order_details" component={OrderDetails} />
      <Route path="/web_app/pnd_order_cancel/order_details" component={OrderCancellationIndex} />
      <Route path="/web_app/pnd_order/order_add" component={OrderCreate} />
      <Route path="/web_app/pnd_order/order_transfer/view" component={OrderTransferDetails} />
      <Route path='/web_app/pnd_order/order_assign/view' component={OrderAssignDetails} />
      <Route path='/web_app/pnd_order/order_reassign/view' component={OrderReassign} />
      <Route path='/web_app/pnd_order/rider-wise-order/view/:id' component={RiderWiseOrder} />
      <Route path='/web_app/pnd_order/order_edit/:id' component={OrderEdit} />
      <Route path='/web_app/pnd_order/order-reschedule' component={OrderReschedule} />
      <Route path='/web_app/pnd_order/merchant/order_recall' component={OrderRecall} />

      <Route path='/web_app/pnd_order/merchant/view' component={MerchantDetails} />
      <Route path='/web_app/pnd_merchant/customer/view' component={MerchantCustomer} />
      <Route path='/web_app/pnd_merchant/customer_addres_book/view' component={MerchantCustomerAddrssBook} />
      <Route path='/web_app/rider/duty_roaster/view' component={DutyRoasterView} />
      <Route path='/web_app/rider/duty_roaster/registration' component={DutyRoasterRegistration} />
      <Route path='/web_app/rider/location_history' component={RiderLocationHistory} />
      <Route path='/web_app/rider/availability' component={RiderAvailability} />
      <Route path='/web_app/rider/live_map' component={RiderLiveMap} />
      <Route path='/web_app/rider/trip_history' component={TripHistory} />


      <Route path='/web_app/views/hub_operators/view' component={HubOperatorView} />
      <Route path='/web_app/views/rider_view' component={RiderView} />
      <Route path='/web_app/views/vehicle_view' component={VehicleView} />
      <Route path='/web_app/views/hub_view' component={HubView} />
      <Route path='/web_app/views/driver_employer_view' component={DriverEmployerView} />
      <Route path='/web_app/views/order/cancelled_order_view' component={CanclledOrderView} />
      <Route path='/web_app/views/order/withdrew_order_view' component={WithdrewOrderView} />
      <Route path='/web_app/views/order/punched_order_view' component={OrderPunchingOrderView} />
      <Route path='/web_app/views/general/subcscription_view' component={ClientAdminScubscriptionDetailsView} />
      <Route path='/web_app/views/general/merchant_view' component={MerchantView} />

      <Route path='/web_app/rider/roaster_history' component={DutyRoasterHistory} />
      <Route path='/web_app/report/statistical_report' component={StatisticalReport} />

      <Route path='/web_app/report/duty_report' component={RiderDutyReport} />
      <Route path='/web_app/report/rider_activity_report' component={RiderActivitySummaryReport} />
      <Route path='/web_app/report/order_summary_report' component={OrderSummaryReport} />
      <Route path='/web_app/report/order_detailed_report' component={OrderDetailedReport} />

      <Route path='/web_app/report/order_performance_report' component={OrderPerformanceReport} />
      <Route path='/web_app/report/order_otr_report' component={OrderOTRReport} />
      <Route path='/web_app/report/order_report' component={OrderReport} />
      <Route path='/web_app/report/order_otr_interval_report' component={OTRIntervalReport} />
      <Route path='/web_app/report/complaint_dlv_report' component={OrderComplainceDlvReport} />
      <Route path='/web_app/report/order_failed_report' component={OrderFailedReport} />

      <Route path='/web_app/order/security_approval' component={SecurityApproval} />
      <Route path='/web_app/order/decline' component={DeclineOrder} />
      <Route path='/web_app/order/approval/details' component={OrderDetailsPage} />
      <Route path='/web_app/security/history' component={SecurityHistory} />
      <Route path='/web_app/security/report' component={SecurityReport} />
      <Route path='/web_app/order/preference_settings' component={OrderPreferenceSettings} />


   </Switch>
);
